import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../../components/Button";
import {
  ButtonContainer,
  CancelButton,
  confirmModalCss,
  ContentContainer,
  ModalSubtitle,
} from "../../CustomOptionsBar.styles";

type ArchiveBaselineModalProps = {
  baseline: number;
  unit?: string;
  isISHLTBaseline: boolean;
  decimalPlaces?: number;
  onClose: (confirm: boolean, isISHLTBaseline: boolean) => void;
};

export function ArchiveBaselineModal({
  baseline,
  unit,
  isISHLTBaseline,
  decimalPlaces,
  onClose,
}: ArchiveBaselineModalProps) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmDelete = () => {
    setIsLoading(true);
    onClose(true, isISHLTBaseline);
  };

  const handleCancel = () => {
    onClose(false, isISHLTBaseline);
  };

  const handleText = () => {
    if (isISHLTBaseline) {
      return t("patientPage_measurementModal_baselineModal_deleteIshltBody", {
        value: `${baseline.toFixed(decimalPlaces)}${unit ?? ""}`,
      });
    }

    return t("patientPage_measurementModal_baselineModal_deleteBody", {
      value: `${baseline.toFixed(decimalPlaces)}${unit ?? ""}`,
    });
  };

  return (
    <Modal
      title={t("patientPage_measurementModal_baselineModal_confirmChanges")}
      open
      zIndex={3001}
      footer={null}
      width={500}
      onCancel={handleCancel}
      className={confirmModalCss()}
      centered
    >
      <ContentContainer>
        <ModalSubtitle>{handleText()}</ModalSubtitle>
        <ButtonContainer>
          <Button
            label={t("patientPage_measurementModal_baselineModal_confirm")}
            type="button"
            onClick={handleConfirmDelete}
            isLoading={isLoading}
          />

          <CancelButton isModal onClick={handleCancel}>
            {t("common_cancel")}
          </CancelButton>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}
